import React, { useEffect, useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { DialogBox, Icon, Spinner } from 'xm-spark';

import {
  XMATTERS_SIGN_ON_RELOGIN_URL,
  XMATTERS_SIGN_ON_URL,
} from 'xm-constants/urls';
import helpViewStyle from 'Application/HelpView/HelpView.module.scss';
import { LOGGING_IN } from 'pages/SignOn/components/Login/Login';
import style from './ReloginDialog.module.scss';

export default function ReLoginDialog({
  isLoading,
  isOpen,
  hideReloginDialog,
  setReloginDialogLoaded,
  setReloginDialogLoading,
}) {
  const [contentRef, setContentRef] = useState(null);

  const triggerLoadingEvtListener = useCallback(
    event => {
      if (event?.data?.type === LOGGING_IN) {
        setReloginDialogLoading();
      }
    },
    [setReloginDialogLoading],
  );

  useEffect(() => {
    window.addEventListener('message', triggerLoadingEvtListener);
    return () =>
      window.removeEventListener('message', triggerLoadingEvtListener);
  }, [triggerLoadingEvtListener]);

  const handleLoad = () => {
    const href = contentRef?.contentWindow?.location?.href;
    if (href.includes(XMATTERS_SIGN_ON_URL)) {
      setReloginDialogLoaded();
    }
  };

  return (
    <DialogBox
      classes={{
        content: style.dialogContent,
        backdrop: `${
          style.dialogBackdrop || ''
        } ${helpViewStyle.overlapsHelpViewBackdrop || ''}`,
        header: style.dialogHeader,
        wrap: style.wrap,
      }}
      isOpen={isOpen}
      simpleStyle
      onClose={() => {
        hideReloginDialog();
      }}
    >
      {isLoading && <Spinner centered />}
      <div>
        {!isLoading && (
          <div>
            <a href={XMATTERS_SIGN_ON_URL}>
              <Icon type="icon-left" />{' '}
              <FormattedMessage id="BACK_TO_LOGIN_PAGE" />
            </a>
          </div>
        )}
        <div>
          <iframe
            width="500"
            height="700"
            className={style.iframe}
            ref={setContentRef}
            src={XMATTERS_SIGN_ON_RELOGIN_URL}
            frameBorder="0"
            onLoad={handleLoad}
            hidden={isLoading}
            title="reloginDialog"
            data-testid="relogin-iframe"
          />
        </div>
      </div>
    </DialogBox>
  );
}

ReLoginDialog.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  hideReloginDialog: PropTypes.func.isRequired,
  setReloginDialogLoaded: PropTypes.func.isRequired,
  setReloginDialogLoading: PropTypes.func.isRequired,
};
